import moment from 'moment';
import { GrFormNextLink } from 'react-icons/gr';
import { IoArrowBack } from 'react-icons/io5';
import { RiScreenshotFill } from 'react-icons/ri';
import { Button } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IoMdRefresh } from 'react-icons/io';
import { getDashboardScreenshot } from '../../../redux/MainAction';

const ImagesCard = () => {
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const screenshot = useSelector(
    (state) => state.Webtracker.dashboardScreenShot
  );

  async function fetchDashboardData(isFirstRefresh) {
    setIsLoading(true);
    if (isFirstRefresh) setFirstRefresh(true);

    var sc = {
      date: moment(new Date()).format('YYYY-MM-DD'),
    };

    await dispatch(getDashboardScreenshot(sc));

    setIsLoading(false);
  }

  // image logic
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState([]);

  const imagesPerPage = windowSize?.width < 1500 ? 4 : 6;

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      Math.min(prevIndex + imagesPerPage, images.length - 1)
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - imagesPerPage, 0));
  };

  const displayedImages = images.slice(
    currentIndex,
    currentIndex + imagesPerPage
  );

  useEffect(() => {
    if (screenshot && screenshot?.rows) {
      setImages(screenshot?.rows);
    }
  }, [screenshot]);

  return (
    <div className="col-12">
      <div className="card  m-b-20 enhanced-card">
        <div className="border_class d-flex align-items-center justify-content-between">
          <h5 className="card-title font-20 ml-3">
            <RiScreenshotFill
              className=" mr-1 dash-text-primary"
              style={{ fontSize: '25px' }}
            />{' '}
            Screenshots
          </h5>

          {firstRefresh ? (
            <IoMdRefresh
              onClick={fetchDashboardData}
              title="Refresh Screenshots"
              className="dashboard_reload_icon"
            />
          ) : null}
        </div>

        <div className="card-body dash_cards " style={{ minHeight: '200px' }}>
          {isLoading ? (
            <div
              className="d-flex align-items-center justify-content-center h-100"
              style={{ minHeight: '200px' }}
            >
              <div className="spinner-border text-primary " role="status"></div>
            </div>
          ) : firstRefresh ? (
            <>
              <div className="d-flex flex-wrap">
                {displayedImages?.length === 0 ? (
                  <h4 className="d-flex align-items-center justify-content-center w-100 text-secondary">
                    No screenshots to display
                  </h4>
                ) : (
                  displayedImages?.map((image, index) => (
                    <div key={index} className="text-center m-2">
                      <img
                        className="rounded border "
                        alt={`Thumbnail ${currentIndex + index + 1}`}
                        style={{ width: '200px' }}
                        src={image?.media?.url}
                        data-holder-rendered="true"
                      />
                      <div className="mt-1 d-flex justify-content-between">
                        <span className="font-14">
                          {image?.user?.firstName} {image?.user?.lastName}
                        </span>
                        <span className="font-14">
                          {moment(image?.media?.createdAt).format('h:mm:ss')}
                        </span>
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="d-flex justify-content-between mt-3">
                <Button
                  color="primary"
                  size="sm"
                  onClick={handlePrev}
                  disabled={currentIndex === 0}
                >
                  <IoArrowBack className="font-20" /> Previous
                </Button>
                <Button
                  color="primary"
                  size="sm"
                  onClick={handleNext}
                  disabled={currentIndex + imagesPerPage >= images.length}
                >
                  Next <GrFormNextLink className="font-20" />
                </Button>
              </div>
            </>
          ) : (
            <div
              className="d-flex align-items-center justify-content-center h-100"
              style={{ minHeight: '200px' }}
            >
              <button
                className="btn btn-primary font-14"
                onClick={() => fetchDashboardData(true)}
              >
                Load Screenshots
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImagesCard;
